// Node.js polyfills for browser environment
import { Buffer } from "buffer";
import process from "process";
import * as util from "util";

// Make Buffer globally available
window.Buffer = Buffer;
globalThis.Buffer = Buffer;

// Make process globally available
window.process = process;
globalThis.process = process;

// Populate process.env with Vite's environment variables
// Vite exposes env vars through import.meta.env
if (import.meta.env) {
	process.env = process.env || {};
	Object.keys(import.meta.env).forEach(key => {
		process.env[key] = import.meta.env[key];
	});
}

// Make util globally available
window.util = util;
globalThis.util = util;

export {};
